module.exports = __webpack_public_path__ + "static/media/ana-furniture_2x.365c0b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/ana-furniture_2x.jpg
// module id = 808
// module chunks = 27